"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextToDialogueConvertRequestOutputFormat = void 0;
exports.TextToDialogueConvertRequestOutputFormat = {
    Mp32205032: "mp3_22050_32",
    Mp34410032: "mp3_44100_32",
    Mp34410064: "mp3_44100_64",
    Mp34410096: "mp3_44100_96",
    Mp344100128: "mp3_44100_128",
    Mp344100192: "mp3_44100_192",
    Pcm8000: "pcm_8000",
    Pcm16000: "pcm_16000",
    Pcm22050: "pcm_22050",
    Pcm24000: "pcm_24000",
    Pcm44100: "pcm_44100",
    Pcm48000: "pcm_48000",
    Ulaw8000: "ulaw_8000",
    Alaw8000: "alaw_8000",
    Opus4800032: "opus_48000_32",
    Opus4800064: "opus_48000_64",
    Opus4800096: "opus_48000_96",
    Opus48000128: "opus_48000_128",
    Opus48000192: "opus_48000_192",
};
